
<div class="modal-dialog" style="max-width: 500px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Edit Alert</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <form [formGroup]="alert.formGroup" (ngSubmit)="save()">
        <div class="form-group">
          <label class="form-control-label required" for="alertHeader">Header</label>
          <input class="form-control" id="alertHeader" type="text" formControlName="header" name="header">
          <div class="validation-issue-block" *ngIf="header.invalid &amp;&amp; (header.dirty || header.touched)">
            <div class="validation-issue" *ngIf="header.errors.required">Header is required.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="form-control-label required" for="alertText">Text</label>
          <textarea class="form-control" id="alertText" formControlName="text" name="text"></textarea>
          <div class="validation-issue-block" *ngIf="text.invalid &amp;&amp; (text.dirty || text.touched)">
            <div class="validation-issue" *ngIf="text.errors.required">Text is required.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="form-control-label" for="alertBulletPoints">Bullet Points (1 per line)</label>
          <textarea class="form-control" id="alertBulletPoints" formControlName="bulletPoints" name="bulletPoints"></textarea>
        </div>
        <div class="form-group">
          <label class="form-control-label" for="alertFooter">Footer</label>
          <textarea class="form-control" id="alertFooter" formControlName="footer" name="footer"></textarea>
        </div>
        <div class="form-group">
          <label class="form-control-label required" for="alertPriority">Priority</label>
          <input class="form-control" id="alertPriority" type="number" formControlName="priority" name="priority" min="1" max="99">
          <div class="validation-issue-block" *ngIf="priority.invalid &amp;&amp; (priority.dirty || priority.touched)">
            <div class="validation-issue" *ngIf="priority.errors.required">Priority is required.</div>
            <div class="validation-issue" *ngIf="priority.errors.min">Priority must be 1 or greater.</div>
            <div class="validation-issue" *ngIf="priority.errors.max">Priority must be 99 or less.</div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
    </div>
  </div>
</div>